import {
  BANK_CODES,
  BANK_NAMES,
  type BankId,
} from '@energy-retailer/constants';
import get from 'lodash/get';

export const getBankDetails = (
  bsb: string
): {
  bankId: string;
  bankNumber: string;
  branchNumber: string;
} => {
  const [bankNumber = '', branchNumber = ''] = bsb.split('-');
  const bankCode = get(BANK_CODES, bankNumber) as BankId;
  const bankId = BANK_NAMES[bankCode] as string;

  return {
    bankId,
    bankNumber,
    branchNumber,
  };
};
